/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Tenant Admin Report Results Component
  Date: Sept, 2020
**/

import React from 'react';
import {
  Link,
  makeStyles,
  Grid,
  Tooltip,
  IconButton,
  Typography,
  AppBar,
  Box,
  // Table,
  // TableBody,
  // TableCell,
  // TableContainer,
  // TableHead,
  // TableRow,
  Dialog,
  DialogContent,
  DialogActions,
  Button
} from '@material-ui/core';
import moment from 'moment';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
// import BackButton from '@material-ui/icons/ArrowBack';
import { EmptyListingTable, EnhancedTable } from '../../components';
import { useStoreState, useStoreActions } from 'easy-peasy';
import { stringConstants } from '../../constants/stringConstants';
import LocalStorageService from '../../services/localStorage';
import DisplayBreadcrumbs from '../../components/displayBreadcrumbs/displayBreadcrumbs';
const useStyles = makeStyles((theme) => ({
  exportButton: {
    padding: '6px 16px',
    textDecoration: 'none',
  },
  gridContainer: {
    padding: '20px 0 0',
  },
  formTopBar: {
    width: '100%',
    zIndex: '100',
    padding: '.5% 0px .5% .2%',
    backgroundColor: 'rgb(255, 255, 255)',
    boxShadow: 'rgba(0, 0, 0, 0.75) 0px 0px 9px 0px',
  },
  paddingLeft20:{paddingLeft:'20px!important'}
}));

const CustomReportResult = (props) => {
  const classes = useStyles();
  let search = window.location.search;
  let params = new URLSearchParams(search);
  
  const reportAction = useStoreActions((actions) => actions.report);
  const reportState = useStoreState((state) => state.report);
  const skipPageReset = false;
  const [customField, setCustomField] = React.useState({});
  const [nofound, setNofound] = React.useState(false);

  const [isOpen, setIsOpen] = React.useState(false);
  const [isProcessingStartedPopup, setIsProcessingStartedPopup] = React.useState(false);
  
  const [totalNumber, setTotalNumber] = React.useState(0);
  // const [tableHeader, setTableHeader] = React.useState('');

  const [fileAlreadyRequested, setFileAlreadyRequested] = React.useState(false);
  const [fileAlreadyRequestedMsg, setFileAlreadyRequestedMsg] = React.useState('');

  const [fileProcessingMsg, setFileProcessingMsg] = React.useState('');

  const localStorageService = LocalStorageService.getService();

  const downloadReport = (event, reportId) => {
    event.preventDefault();
    reportAction.getReportFile(reportId).then(function (response) {
    }).catch(function (error) {      
      if(error.response.status === 434) {
        setFileAlreadyRequested(true);
        setFileAlreadyRequestedMsg(error.response.data.error);
      }
    });
  };

  React.useEffect(() => {
    if(reportState.reportFileUrl?.data?.success) {
      localStorageService.setNotification(true);
      setFileProcessingMsg(reportState.reportFileUrl.data.data.message);
      setIsProcessingStartedPopup(true);
    }
  }, [reportState.reportFileUrl?.data?.success]);

  React.useEffect(() => {
    setIsProcessingStartedPopup(false);
    setFileAlreadyRequested(false);
    let query = props.reportID;
    if(props.history?.location?.search){
      query += props.history.location.search;
    }
    reportAction.getReportresultList(query).then(function (response) {
      //console.log('response', response);
    })
    .catch(function (error) {
      setNofound(true);
    });
  }, []);

  React.useEffect(() => {
    if(fileAlreadyRequested) {
      setIsOpen(true);
    }
  }, [fileAlreadyRequested, fileAlreadyRequestedMsg]);

  React.useEffect(() => {
    reportState.reportresultList?.Items?.map(e => {
      if(e.total_transactions) {
        setTotalNumber(e.total_transactions);
      }
    })
    // reportState.reportresultList?.tableHeadersFormatted?.map(e => {
    //   setTableHeader(e?.replaceAll('_', ' '));
    // })
    
  }, [reportState.reportresultList.Items, reportState.reportresultList.tableHeaders])
  

  React.useEffect(() => {
    if (reportState.reportresultList?.tableHeadersFormatted && reportState.reportresultList?.tableHeaders) {
      let fields = reportState.reportresultList.tableHeaders.map((field, index) => {
        return {
          Header: reportState.reportresultList.tableHeadersFormatted?.[index]?.replaceAll('_', ' '),
          accessor: field,
          Cell: ({ row }) => {
            return (<>{row.original[field]?row.original[field]:''}</>);
          },
          procedureClass: true
        };
      });
      setCustomField(fields);
      if (reportState.reportresultList.tableHeaders.length === 0) {
        setNofound(true);
      } else {
        setNofound(false);
      }
    }
  }, [reportState.reportresultList]);

  const handleClose = () => {
    setIsOpen(false);
    setFileAlreadyRequested(false);
  }

  const handleCloseProcessingPopup = () => {
    setIsProcessingStartedPopup(false);
  }

  return (
    <Grid container direction="row" style={{ backgroundColor: '#fff' }}>
      {/* <Grid item md={12} className={`${classes.formTopBar}`}>
        <div style={{ display: 'flex' }}>
          <Tooltip title="Go Back">
            <IconButton
              color="primary"
              onClick={() => { reportAction.setCustomReport(null); props.history.push(props.reportType==='standard'?`/reports/standard`:`/standardreport/${props.reportID}`);}}
            >
              <BackButton fontSize="large" />
            </IconButton>
          </Tooltip>
          <Typography variant="h5" style={{ paddingTop: '13px' }}>
            <span style={{ fontSize: '20px' }}>Report</span>
          </Typography>
        </div>
      </Grid> */}
      <Grid item md={12} xs={12}>         
        <DisplayBreadcrumbs items={[{ title: "Standard Reports", link: "/reports/standard" }, { title: 'Execute Report Results', link: '' }]} />
      </Grid>
      {reportState.reportresultList?.reportMeta && (
        <>
          <Grid item md={12} className={classes.gridContainer} style={{paddingTop:'0px', position: 'absolute', right: '0px', marginTop: '50px'}}>
            {reportState.reportresultList && reportState.reportresultList.Items && customField && customField.length > 0 && (
              <div
                style={{
                  display: 'flex',
                  textAlign: 'right',
                  float: 'right',
                  marginRight: '40px',
                }}
              >
                {/* {reportState.reportresultList.report_file !== 'NOT_AVAILABLE' && (
                  <Link href={reportState.reportresultList && reportState.reportresultList.report_file} onClick={(event) => downloadReport(event, props.reportID)}>
                    <Tooltip title="Download Report">
                      <IconButton
                        color="primary"
                        aria-label="Download Report"
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </Tooltip>
                  </Link>
                )} */}
              </div>
            )}
            <Dialog
              disableBackdropClick
              disableEscapeKeyDown
              maxWidth="sm"
              aria-labelledby="confirmation-dialog-title"
              open={isOpen}
              PaperProps={{
                style: { borderRadius: 20 }
              }}
            >
              <DialogContent>
                <Grid container>
                  <Typography style={{paddingTop: '30px', paddingBottom: '30px', fontSize: '14px', textAlign: 'center'}}>{fileAlreadyRequestedMsg}</Typography>
                </Grid>
              </DialogContent>
              <DialogActions style={{padding: '0 35px 30px'}}>
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  spacing={2}
                >
                  <Grid item>
                    <Button
                      onClick={handleClose}
                      variant="contained"
                      color="secondary"
                    >
                      Close
                    </Button>
                  </Grid>
                </Grid>
              </DialogActions>
            </Dialog>
            <Dialog
              disableBackdropClick
              disableEscapeKeyDown
              maxWidth="sm"
              aria-labelledby="confirmation-dialog-title"
              open={isProcessingStartedPopup}
              PaperProps={{
                style: { borderRadius: 20 }
              }}
            >
              <DialogContent>
                <Grid container>
                  <Typography style={{paddingTop: '30px', paddingBottom: '30px', fontSize: '14px', textAlign: 'center'}}> {fileProcessingMsg} </Typography>
                </Grid>
              </DialogContent>
              <DialogActions style={{padding: '0 35px 30px'}}>
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  spacing={2}
                >
                  <Grid item>
                    <Button
                      onClick={handleCloseProcessingPopup}
                      variant="contained"
                      color="secondary"
                    >
                      Close
                    </Button>
                  </Grid>
                </Grid>
              </DialogActions>
            </Dialog>
          </Grid>
          
          <Grid item md={12}>
            <Box style={{margin: '50px 20px', overflow: 'hidden', position: 'relative'}}>
              <Box style={{float: 'left', position: 'relative', width: '75%'}}>
                <Box style={{float: 'left'}}>
                  <Box display="flex" flexDirection="row" style={{position: 'relative'}}>
                    <Box style={{fontSize: '19px'}}>
                      <Typography variant="h6" component="h6" style={{textTransform: 'none'}}>
                        {reportState.reportresultList.reportMeta.report_title}  
                      </Typography>
                    </Box>
                  </Box>
                  <Box display="flex" flexDirection="row" style={{marginTop: '10px'}}>
                    <Box style={{fontSize: '14px'}}>
                      <strong>Tenant Name:</strong> {reportState.reportresultList && reportState.reportresultList.reportMeta && reportState.reportresultList.reportMeta.orgs_title ? reportState.reportresultList.reportMeta.orgs_title : 'N/A'}
                    </Box>
                    {reportState.reportresultList && reportState.reportresultList.reportMeta && reportState.reportresultList.reportMeta.date_filter && (
                      <>
                        <Box style={{fontSize: '14px', marginLeft: '40px'}}>
                          <strong>From Date:</strong> {params.get('from_date') ? moment(params.get('from_date')).format('MM-DD-YYYY') : 'N/A'}
                        </Box>
                        <Box style={{fontSize: '14px', marginLeft: '40px'}}>
                          <strong>To Date:</strong> {params.get('to_date') ? moment(params.get('to_date')).format('MM-DD-YYYY') : 'N/A'}
                        </Box>
                      </>
                    )}
                  </Box>
                  {!totalNumber ? (<></>) : (
                    <Box display="flex" flexDirection="row" style={{marginTop: '10px'}}>
                      <Box style={{fontSize: '14px'}}>
                        <strong>Transaction Count:</strong> {totalNumber}
                      </Box>
                    </Box>
                  )}
                </Box>
              </Box>
              <Box style={{position: 'absolute', right: '0px'}}>
                <Typography style={{float: 'left', cursor: 'pointer', fontSize: '14px'}} variant="h6" component="h6" onClick={() => props.history.push('/reports/standard') }>
                  <KeyboardBackspaceIcon style={{position: 'relative', top: '7px'}} /> Back to List
                </Typography>
                {reportState.reportresultList.report_file !== 'NOT_AVAILABLE' && (
                  <Link style={{marginLeft: '10px', position: 'relative', top: '-5px'}} href={reportState.reportresultList && reportState.reportresultList.report_file} onClick={(event) => downloadReport(event, props.reportID)}>
                    <Tooltip title="Download Report">
                      <IconButton
                        color="primary"
                        aria-label="Download Report"
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </Tooltip>
                  </Link>
                )}
              </Box>
            </Box>
            {/* <TableContainer style={{}}>
              <Table className={classes.table} aria-label="simple table" width="300">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.paddingLeft20}><strong>{reportState.reportresultList.reportMeta.report_title}</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {reportState.reportresultList?.reportMeta?.orgs_title && (
                  <TableRow>
                    <TableCell component="th" scope="row" className={classes.paddingLeft20}>
                      {reportState.reportresultList.reportMeta.orgs_title}
                    </TableCell>
                  </TableRow>
                  )}
                  {reportState.reportresultList.reportMeta.entity_filter && (
                  <TableRow>
                    <TableCell component="th" scope="row" className={classes.paddingLeft20}>
                      {reportState.reportresultList?.reportMeta?.entity_filter}
                    </TableCell>
                  </TableRow>
                  )}
                  {reportState.reportresultList?.reportMeta?.date_filter && (
                  <TableRow>
                    <TableCell component="th" scope="row" className={classes.paddingLeft20}>
                      {reportState.reportresultList.reportMeta.date_filter}
                    </TableCell>
                  </TableRow>
                  )}
                  <TableRow>
                    <TableCell component="th" scope="row" className={classes.paddingLeft20}>&nbsp;</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell component="th" scope="row" className={classes.paddingLeft20}>&nbsp;</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer> */}
          </Grid>
        </>
      )}
      {reportState.reportresultList && reportState.reportresultList.Items && customField && customField.length > 0 && (
        <Grid container direction="row">
          <Grid item md={12} className={classes.gridContainer} style={{paddingTop:'0px'}}>            
            {!totalNumber && (
              <>
                <AppBar position="static">
                  <Typography variant="h6" color="inherit" component="h6" style={{color: '#fff', textTransform: 'uppercase', margin: '8px 20px'}}>
                    Report Details
                  </Typography>
                </AppBar>
                <EnhancedTable
                  // paging={true}
                  paginationDefauldSize={25}
                  columns={customField}
                  data={reportState.reportresultList.Items}
                  rowSelection={false}
                  skipPageReset={skipPageReset}
                  toolbar={{
                    show: false,
                    title: 'Report Preview',
                    enableSearch: true,
                    actionButtonGroup: (selected) => {
                      return (
                        <div style={{ display: 'flex', width: '105px' }}>
                          {/* {reportState.reportresultList.report_file !== 'NOT_AVAILABLE' && (
                            <Link href={reportState.reportresultList && reportState.reportresultList.report_file} onClick={(event) => downloadReport(event, props.reportID)}>
                            <Tooltip title="Download Report">
                              <IconButton
                                color="primary"
                                aria-label="Download Report"
                              >
                                <CloudDownloadIcon />
                              </IconButton>
                            </Tooltip>
                          </Link>
                          )} */}
                        </div>
                      );
                    },
                  }}
                />
              </>
            )}          
            {/* <TableContainer style={{}}>
              <Table className={classes.table} aria-label="simple table" width="300">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.paddingLeft20} align="right"><strong>Viewing {reportState.reportresultList && reportState.reportresultList.Items && (reportState.reportresultList.Items.length)} of {reportState.reportresultList && (reportState.reportresultList.rowCount)}</strong></TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </TableContainer> */}
          </Grid>
          <Grid item md={12} className={classes.gridContainer}>
            <div
              style={{
                display: 'flex',
                textAlign: 'right',
                float: 'right',
                marginRight: '40px',
              }}
            >
              {/* {reportState.reportresultList.report_file !== 'NOT_AVAILABLE' && (
                  <Link href={reportState.reportresultList && reportState.reportresultList.report_file} onClick={(event) => downloadReport(event, props.reportID)}>
                  <Tooltip title="Download Report">
                    <IconButton
                      color="primary"
                      aria-label="Download Report"
                    >
                      <CloudDownloadIcon />
                    </IconButton>
                  </Tooltip>
                </Link>
              )} */}
            </div>
          </Grid>
        </Grid>
      )}
      {nofound && (
        <Grid item md={12} >
          <div style={{ display: 'flex', margin: '20px' }}>
          {props.reportType==='standard'?(
            <EmptyListingTable
              addPermition={true}
              propsHistory={props.history}
              addFormLink={`/reports/standard`}
              textMsg={stringConstants.noRecordFound}
              butnText={`Back to Reports`}
            />):(<EmptyListingTable
              addPermition={true}
              propsHistory={props.history}
              addFormLink={`/reports/standard`}
              textMsg={stringConstants.noRecordFound}
              butnText={`Back to Report`}
            />)}
          </div>
        </Grid>
      )}
      <style>
        {`
        .MuiTableCell-body{     text-transform: capitalize;}
      `}
      </style>
    </Grid>
  );
};

export default CustomReportResult;
